
import React, { useState, useContext, useCallback } from 'react';
import AccessibilitySummaryEditor from '../../containers/SidebarMenu/AccessibilitySummaryEditor';
import { useDocumentContext } from '../../context/complexDocumentContext';
import { PageElementsContext } from '../../context/pageElementsContext';


const GetAlternativeTextFromValidator = ({ elementUUID, blockID, flowID, setSummarySave, globalVariables, accessibilityContext, setAccessibilityContext, flow, isEmail, updateSocialMediaContent, socialMediaType }) => {

  const { updateComplexElementDetails } = useContext(PageElementsContext);
  
  const updateAccessibleSummary = (providedAltText) => {
    const hasSummary = providedAltText?.contents && providedAltText?.contents?.length ? providedAltText.contents.some(item => {
      const content = item.content?.trim();
      return content && content !== '\n';
    }) : false;
    if (isEmail && hasSummary) {
      updateSocialMediaContent(providedAltText.contents, socialMediaType, blockID);
    } else {
      updateComplexElementDetails(elementUUID, { summary: providedAltText.contents }, 'style');
    }
    setSummarySave(true)

    removeAlternativeTextByElementUUID(flow, elementUUID);

  };
const removeAlternativeTextByElementUUID = (pageKey, targetUUID) => {
  setAccessibilityContext(prevState => {
    const updatedPage = {
      ...prevState[pageKey],
      alternativeText: prevState[pageKey].alternativeText.filter(
        item => item.elementUUID !== targetUUID
      ),
    };
    return {
      ...prevState,
      [pageKey]: updatedPage,
    };
  });
};

  return (
    <>
      <AccessibilitySummaryEditor
        key={elementUUID}
        itemUUID={`alt-text-${elementUUID}`}
        contents={''}
        customContainerStyle={{ marginTop: 10 }}
        onSaveChanges={updateAccessibleSummary}
        customizeHistory={false}
        customClassName={'summary-editor'}
      />
    </>
  );
};

export default GetAlternativeTextFromValidator;
